import React from "react";
import { Box, Stack } from "@chakra-ui/core";
import { FaLock } from "react-icons/fa";

function BrowserTopBarMockup() {
  return (
    <Stack
    bg="primary.100"
    isInline
    borderWidth="1px"
    borderTopRightRadius="8px"
    borderTopLeftRadius="8px"
  >
    <Stack borderWidth="1px" isInline my="3" px={2} spacing={2} w="20%">
      <Box
        w="10px"
        h="10px"
        bg="primary.transparent-300"
        borderRadius="50%"
      ></Box>
      <Box
        w="10px"
        h="10px"
        bg="primary.transparent-300"
        borderRadius="50%"
      ></Box>
      <Box
        w="10px"
        h="10px"
        bg="primary.transparent-300"
        borderRadius="50%"
      ></Box>
    </Stack>
    <Stack borderWidth="1px" justifyItems="center" w="60%">
      <Box
        maxW="400px"
        px={2}
        py={1}
        m="auto"
        borderRadius="3px"
        bg="primary.transparent-100"
        w="70%"
      >
        <Stack isInline justifyContent="center" alignItems="center">
          <Box as={FaLock} size="10px" color="primary.300" />
          <Box bg="primary.300" w="60%" h="8px" borderRadius="10px" />
        </Stack>
      </Box>
    </Stack>

  </Stack>
  );
}

export default BrowserTopBarMockup;